export default "__VITE_ASSET__BWAJlMsZ__"